<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <v-card>
      <v-toolbar color="primary" dark text>
        <v-toolbar-title>Save a new location</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-5">
        <v-text-field
          label="Name your district"
          outlined
          v-model="name"
          :error-messages="errors.name"
          class="select-bordered"
        />
        <p>
          Type or paste your locations below. You can put each location on a new line or separate them using commas. Learn more.
        </p>
        <v-textarea
          outlined
          name="input-7-4"
          :placeholder="`Examples:\n94025\n90007\n94015, 94014`"
          :error-messages="errors.zip"
          v-model="postCodes"
          class="select-bordered"
        />
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="closeDialog"
        >
          Close
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="saveLocations"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'GeoAddSavedLocation',
    data () {
      return {
        name: '',
        postCodes: '',
        errors: {
          name: [],
          zip: []
        }
      }
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      locations: {
        type: Object,
        default: () => []
      }
    },
    methods: {
      closeDialog () {
        this.$emit('closeDialog')
      },
      saveLocations () {
        if (!this.formValidation()) return false
        const locations = {
          name: this.name,
          locations: this.codesToArray()
        }
        this.$store.dispatch('createLocations', locations)
        this.$emit('closeDialog')
      },
      zipCodesValidation () {
        const regex = /^\d{5}(?:[-\s]\d{4})?$/
        return this.codesToArray().filter(zip => !regex.test(zip.trim()))
      },
      formValidation () {
        let valid = true
        this.errors.name = []
        this.errors.zip = []
        if (this.zipCodesValidation().length) {
          const codes = this.zipCodesValidation().join(', ')
          const notification = {
            type: 'warning',
            message: [`The following zip codes are invalid: ${codes}.  Please correct your zip code list`]
          }
          this.$store.dispatch('showNotification', notification)
          valid = false
        }
        if (!this.postCodes) {
          this.errors.zip.push('The field is required')
          valid = false
        }
        if (!this.name) {
          this.errors.name.push('The field is required')
          valid = false
        }
        return valid
      },
      codesToArray () {
        return this.postCodes ? this.postCodes.replace(' ', '').split(',').join('\n').split('\n') : []
      }
    }
  }
</script>
